
import HomeContainer from '../containers/HomeContainer';
import wizardRoutes from '../../wizard/routes/wizardRoutes';
import dashboardRoutes from '../../dashboard/routes/dashboardRoutes';
import usersRoutes from '../../users/routes/usersRoutes';
// import groupsRoutes from '../../groups/routes/groupsRoutes';

export default {
    path: '/',
    component: HomeContainer,
    routes: [wizardRoutes, dashboardRoutes, usersRoutes]
    // routes: [wizardRoutes, dashboardRoutes, usersRoutes, groupsRoutes]
};
